import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function checkAllFeedStatusService(token) {
    return axios.post(`${CURRENT_API_URL}/amazonProductListing/checkAllFeedStatus`, '', {
        headers: { 
            'Authorization': token,
        }
    }).then(res => {
        return res.data;
    }).catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while updating feed data. please try again later.");
        return false;
    });
}


export default checkAllFeedStatusService;